import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subscribe-area bg-50 position-relative" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "bg-golden ptb-60 position-relative z-1 overflow-hidden" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_6 = { class: "subscribe-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_9 = { class: "subscribe-content" }
const _hoisted_10 = { class: "d-sm-flex" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  type: "submit",
  class: "btn active ms-1 mt-2 mt-sm-0"
}
const _hoisted_13 = { class: "border-style" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.subscribeImage,
                alt: "subscribe"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.heading), 1),
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label" }, "البريد الإلكتروني", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email",
                    class: "form-control",
                    placeholder: _ctx.placeholder,
                    required: ""
                  }, null, 8, _hoisted_11), [
                    [_vModelText, _ctx.email]
                  ]),
                  _createElementVNode("button", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.buttonText), 1)
                  ])
                ])
              ], 32),
              _createElementVNode("p", null, [
                _cache[4] || (_cache[4] = _createTextVNode(" بالضغط على زر الاشتراك فإنك توافق على ", -1)),
                _createVNode(_component_RouterLink, {
                  to: "/terms-conditions",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" الشروط والأحكام. ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("img", {
          src: _ctx.shape3,
          class: "shape shape-3",
          alt: "shape"
        }, null, 8, _hoisted_14),
        _createElementVNode("img", {
          src: _ctx.shape4,
          class: "shape shape-4",
          alt: "shape"
        }, null, 8, _hoisted_15)
      ])
    ])
  ]))
}